import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowshoeNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M9.378 0a7.5 7.5 0 00-6.665 4.06l-.319.618A21.5 21.5 0 000 14.538v11.575c0 3.168 0 8.444 1.241 12.955.628 2.279 1.605 4.497 3.175 6.163C6.029 46.944 8.203 48 11 48s4.97-1.056 6.584-2.769c1.57-1.666 2.548-3.884 3.175-6.163C22 34.558 22 29.28 22 26.113V14.538a21.5 21.5 0 00-2.394-9.86l-.319-.617A7.5 7.5 0 0012.622 0zm-4 5.436a4.5 4.5 0 014-2.436h3.244a4.5 4.5 0 014 2.436l.318.618A18.5 18.5 0 0119 14.538V15H3v-.462a18.5 18.5 0 012.06-8.484zM3 19.322l6.035 7.132-1.018 1.204a3.455 3.455 0 00.194 4.674 3.944 3.944 0 005.578 0 3.455 3.455 0 00.194-4.674l-1.018-1.204L19 19.322v6.723c0 3.232-.009 8.14-1.134 12.227-.56 2.035-1.363 3.732-2.466 4.902C14.342 44.298 12.953 45 11 45c-1.953 0-3.342-.702-4.4-1.826-1.103-1.17-1.906-2.867-2.466-4.902C3.009 34.185 3 29.277 3 26.045zM5.811 18H16.19L11 24.132zM45.287 4.06A7.5 7.5 0 0038.622 0h-3.244a7.5 7.5 0 00-6.665 4.06l-.319.618A21.5 21.5 0 0026 14.538v11.575c0 3.168 0 8.444 1.241 12.955.628 2.279 1.605 4.497 3.175 6.163C32.029 46.944 34.203 48 37 48s4.97-1.056 6.584-2.769c1.57-1.666 2.548-3.884 3.175-6.163C48 34.558 48 29.28 48 26.113V14.538a21.5 21.5 0 00-2.394-9.86zM38.622 3a4.5 4.5 0 014 2.436l.318.618A18.5 18.5 0 0145 14.538V15H29v-.462a18.5 18.5 0 012.06-8.484l.319-.618A4.5 4.5 0 0135.378 3zM29 26.046v-6.724l6.035 7.132-1.018 1.204a3.455 3.455 0 00.194 4.675 3.944 3.944 0 005.578 0 3.455 3.455 0 00.194-4.675l-1.018-1.204L45 19.322v6.723c0 3.232-.009 8.14-1.134 12.227-.56 2.035-1.363 3.732-2.466 4.902C40.342 44.298 38.953 45 37 45s-3.342-.702-4.4-1.826c-1.103-1.17-1.906-2.867-2.466-4.902C29.009 34.185 29 29.277 29 26.045zm8-1.914L31.811 18H42.19z" />
      </g>
    </svg>
  )
);
SvgSportsSnowshoeNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowshoeNormalLarge;
